import { DataRemark } from '../api/DataRemarksApi';
import { UWEEntity } from '../api/types';
import { Form } from '../components/FormComponentTypes';
import dfsSearch from './dfsSearch';
import { makeFieldId } from './getPathFromId';
import Jnx from './jnx';
import { JSONSchema } from './jsonschemaTypes';

export type FormField = {
  id: string;
  name: string;
  path: string;
  dataPath: string;
  type: string;
  structure: string;
  description?: string | null;
  subformName?: string;
  subformTitle?: string;
};

export const extractFormFieldsFromSchema = (schema: JSONSchema, subforms: Record<string, Form> = {}, currentEntity?: UWEEntity): FormField[] => {
  const fields: FormField[] = [];

  if (!schema) return fields;

  Object.entries(schema).forEach(([fieldKey, fieldSchema]) => {
    dfsSearch([[fieldKey, '', fieldSchema, '', undefined, undefined]], (item: any) => {
      const [currentPath, parentName, currentSchema, currentDataPath, subformName, subformTitle] = item;
      if (!currentSchema) return;
      const { type, properties, items, title } = currentSchema;
      const name = title || parentName;

      if (currentSchema['ui:field'] === 'SubformField' && currentSchema['ui:subformName']) {
        const subform = subforms[currentSchema['ui:subformName']];
        const dataPathPrefix = currentDataPath ? `${currentDataPath}.` : '';
        const dataPath = currentSchema['map:field']
          ? `${dataPathPrefix}${typeof currentSchema['map:field'] === 'object' ? currentSchema['map:field']['path'] : currentSchema['map:field']}`
          : currentDataPath;

        if (subform) {
          const sfName = subform.name;
          const sfTitle = subform.title;
          return Object.entries(subform.schema).map(([propName, propSchema]) => {
            const _name = (propSchema as any).title || name || parentName;
            return [`${currentPath}.${propName}`, _name, propSchema, dataPath, sfName, sfTitle];
          });
        }
      }

      let dataPath = currentDataPath;
      if (currentSchema['map:field']) {
        dataPath = currentDataPath ? `${currentDataPath}.${currentSchema['map:field']}` : currentSchema['map:field'];
        let showField = true;
        if (currentEntity && currentSchema['ui:staticShowIf'] != null) {
          const jnx = new Jnx(currentSchema['ui:staticShowIf']);
          showField = jnx.eval({}, '', { formObject: currentEntity });
        }
        if (showField) {
          fields.push({
            id: makeFieldId(currentPath),
            name: title,
            path: currentPath,
            dataPath,
            type: currentSchema.type,
            structure: currentSchema.structure,
            description: currentSchema['akc:fieldDescription'],
            subformName,
            subformTitle,
          });
        }
      }

      switch (type) {
        case 'object': {
          return Object.entries(properties).map(([propName, propSchema]) => [
            `${currentPath}.${propName}`,
            name,
            propSchema,
            dataPath,
            subformName,
            subformTitle,
          ]);
        }

        case 'array': {
          return [[currentPath, name, items, dataPath, subformName, subformTitle]];
        }

        default:
          break;
      }
    });
  });

  return fields;
};

// Finds first non-resolved data remarks
export const getActiveDataRemarkForFieldSchema = (dataRemarksByFieldId: Record<string, DataRemark[]>, id?: string) => {
  if (!id) return null
  const fieldRemarks = dataRemarksByFieldId[id];
  if (!fieldRemarks) return null;

  const remark = fieldRemarks.find(dr => !dr.isResolved);

  return !!remark ? remark : null;
};
